var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAircraftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#khpb760cza)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.762 8.82c.13.042.238-.036.238-.173v-.874a.49.49 0 0 0-.215-.378l-4.57-2.724A.49.49 0 0 1 7 4.294V1.242c0-.137-.042-.354-.094-.482 0 0-.272-.677-.75-.752a.892.892 0 0 0-.154-.016h-.003c-.06 0-.12.006-.178.018l-.054.012-.082.026c-.397.132-.602.708-.602.708-.05.158-.078.321-.083.486v3.052a.49.49 0 0 1-.215.378L.215 7.395A.49.49 0 0 0 0 7.773v.874c0 .137.107.215.238.172l4.524-1.468c.131-.043.238.035.238.173v2.383c0 .137-.09.318-.2.4l-.6.45a.566.566 0 0 0-.2.4v.585c0 .138.108.22.24.181l1.519-.436c.132-.038.348-.038.48 0l1.52.436c.133.038.24-.043.24-.18v-.585a.566.566 0 0 0-.2-.4l-.6-.451a.567.567 0 0 1-.2-.4V7.523c0-.137.108-.215.239-.172l4.524 1.469z",
    fill: "#1B1B1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "khpb760cza"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAircraftIcon);
export default __webpack_public_path__ + "static/media/aircraft-icon.92d5a4eb8fc61fdac9153d1a75ad0362.svg";
export { ForwardRef as ReactComponent };